import { type FC } from 'react';

export const FilterFunnelIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M3.33337 5H16.6667"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83337 10H14.1667"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33337 15H11.6667"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ResultsGridIcon: FC = () => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M9.16671 4.58337H4.58337V9.16671H9.16671V4.58337Z"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4167 4.58337H12.8334V9.16671H17.4167V4.58337Z"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16671 12.8334H4.58337V17.4167H9.16671V12.8334Z"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4167 12.8334H12.8334V17.4167H17.4167V12.8334Z"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
